import React, { forwardRef } from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import './Projects.css';

const Projects = forwardRef(({ isInView }, ref) => {
  const projects = [
    {
      id: 1,
      title: 'Swag Labs Test Automation',
      duration: 'Jan 2024 – Feb 2024',
      description: 'Automated testing of key functionalities on the Swag Lab e-commerce website using Selenium WebDriver and TestNG, following the Page Object Model (POM) design pattern.',
      technologies: 'Java, Selenium, TestNG, POM',
      link: 'https://github.com/samithamichael98/SwagLabs_Automation',
    },
    {
      id: 2,
      title: 'HR Management Application Test Automation',
      duration: 'Jul 2023 – 31 Jul 2023',
      description: 'Automated validation of critical functionalities in an HR management software system using Selenium WebDriver, Java, and TestNG. Designed for maintainable, scalable, and efficient test execution, supporting CI.',
      technologies: 'Java, Selenium, TestNG',
      link: 'https://github.com/samithamichael98/Test-Automation--HR-Management-Application',
    },
    {
      id: 3,
      title: 'Drawing Desk Mobile Application Test Automation',
      duration: '31 Dec 2025',
      description: 'Automated key functionalities of a mobile Drawing Desk application using Appium and Java, focusing on canvas interactions, tool selection, gestures, and UI validation, improving test coverage and performance.',
      technologies: 'Appium, Java',
      link: 'https://github.com/samithamichael98/drawingDeskAutomation',
    },
  ];

  return (
    <section id="projects" className={`Projects ${isInView ? 'is-visible' : ''}`} ref={ref}>
      <h2>My Projects</h2>
      <div className="Projects-grid">
        {projects.map(project => (
          <div key={project.id} className="Project-card">
            <h3>{project.title}</h3>
            <p><strong>Duration:</strong> {project.duration}</p>
            <p><strong>Technologies:</strong> {project.technologies}</p>
            <p>{project.description}</p>
            <a href={project.link} target="_blank" rel="noopener noreferrer">
              View Project <FaExternalLinkAlt style={{ marginLeft: '6px' }} />
            </a>
          </div>
        ))}
      </div>
    </section>
  );
});

export default Projects;
